/**
 * RUG VARIANT PICKER - Padloom Custom Design
 * v12.0 - Fixed Single Selection + Exact Minimog Selectors
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initRugPicker, 150);
  });

  function initRugPicker() {
    var picker = document.querySelector('.rug-picker');
    if (!picker) return;

    var variantsDataEl = document.getElementById('rugVariantsData');
    if (!variantsDataEl) return;
    
    var variants = JSON.parse(variantsDataEl.textContent);
    
    // Elements
    var dropdown = document.getElementById('rugSizeDropdown');
    var dropdownTrigger = document.getElementById('rugDropdownTrigger');
    var sizeOptions = document.querySelectorAll('.rug-size-option');
    var selectedSizeText = document.getElementById('rugSelectedSizeText');
    var sizeInfoContents = document.querySelectorAll('.rug-size-info__content');
    
    var qualityButtons = document.querySelectorAll('.rug-quality-btn');
    var qualityInfoBtn = document.getElementById('rugQualityInfoBtn');
    var modal = document.getElementById('rugQualityModal');
    
    var variantIdInput = document.getElementById('rugVariantId');

    // State
    var selectedSize = null;
    var selectedQuality = null;
    var scrollPosition = 0;
    var isDropdownOpen = false;

    // Hide savings on init
    document.querySelectorAll('.rug-quality-btn__savings').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.rug-quality-btn__price-original').forEach(function(el) {
      el.style.display = 'none';
    });

    // Size Guide Modal Elements
    var sizeGuideBtn = document.getElementById('rugSizeGuideBtn');
    var sizeGuideModal = document.getElementById('rugSizeGuideModal');
    
    // Move modals to body
    if (modal) {
      document.body.appendChild(modal);
      modal = document.getElementById('rugQualityModal');
    }
    if (sizeGuideModal) {
      document.body.appendChild(sizeGuideModal);
      sizeGuideModal = document.getElementById('rugSizeGuideModal');
    }

    var modalClose = document.getElementById('rugModalClose');
    var modalGotIt = document.getElementById('rugModalGotIt');
    var modalOverlay = modal ? modal.querySelector('.rug-modal__overlay') : null;
    
    // Size Guide Modal Elements
    var sizeGuideClose = document.getElementById('rugSizeGuideClose');
    var sizeGuideGotIt = document.getElementById('rugSizeGuideGotIt');
    var sizeGuideOverlay = sizeGuideModal ? sizeGuideModal.querySelector('.rug-modal__overlay') : null;

    // =====================
    // DROPDOWN FUNCTIONS
    // =====================
    function openDropdown() {
      if (!isDropdownOpen) {
        dropdown.classList.add('open');
        isDropdownOpen = true;
      }
    }

    function closeDropdown() {
      if (isDropdownOpen) {
        dropdown.classList.remove('open');
        isDropdownOpen = false;
      }
    }

    if (dropdownTrigger) {
      dropdownTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        isDropdownOpen ? closeDropdown() : openDropdown();
      });
    }

    document.addEventListener('click', function(e) {
      if (dropdown && !dropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    // =====================
    // SIZE OPTION CLICKS
    // =====================
    sizeOptions.forEach(function(option) {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var sizeValue = this.getAttribute('data-size-value');
        var sizeIndex = parseInt(this.getAttribute('data-size-index'));
        var ftValue = this.getAttribute('data-ft');
        var cmValue = this.getAttribute('data-cm');
        
        // Get size letter based on index
        var sizeLetters = ['S', 'M', 'L', 'XL', 'XXL'];
        var sizeLetter = sizeLetters[sizeIndex] || (sizeIndex + 1);

        // Remove active from all, add to this one
        sizeOptions.forEach(function(opt) { opt.classList.remove('active'); });
        this.classList.add('active');
        
        selectedSize = sizeValue;

        // Update trigger - include badge
        var triggerContent = dropdownTrigger.querySelector('.rug-size-dropdown__trigger-content');
        if (triggerContent) {
          triggerContent.innerHTML = '<span class="rug-size-dropdown__trigger-badge">' + sizeLetter + '</span><span class="rug-size-dropdown__trigger-ft">' + ftValue + '</span><span class="rug-size-dropdown__trigger-cm">(' + cmValue + ')</span>';
        }

        // Update header text
        if (selectedSizeText) {
          selectedSizeText.textContent = sizeValue;
        }

        closeDropdown();

        // Update size info
        sizeInfoContents.forEach(function(c) { c.classList.remove('active'); });
        var targetInfo = document.querySelector('.rug-size-info__content[data-size-index="' + sizeIndex + '"]');
        if (targetInfo) targetInfo.classList.add('active');

        // Update prices
        updateAllQualityPrices(variants, selectedSize);
        updateSelectedVariant(variants, selectedSize, selectedQuality);
      });
    });

    // =====================
    // QUALITY BUTTON CLICKS
    // =====================
    qualityButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var qualityValue = this.getAttribute('data-quality-value');

        qualityButtons.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        selectedQuality = qualityValue;

        updateSelectedVariant(variants, selectedSize, selectedQuality);
      });
    });

    // =====================
    // MODAL FUNCTIONS
    // =====================
    function openModal() {
      if (!modal) return;
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      modal.classList.add('active');
      modal.style.display = 'flex';
      document.body.style.cssText = 'overflow:hidden!important;position:fixed!important;top:-' + scrollPosition + 'px;left:0;right:0;width:100%';
      document.body.classList.add('rug-modal-open');
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('active');
      modal.style.display = 'none';
      document.body.style.cssText = '';
      document.body.classList.remove('rug-modal-open');
      window.scrollTo(0, scrollPosition);
    }

    // Size Guide Modal Functions
    function openSizeGuideModal() {
      if (!sizeGuideModal) return;
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      sizeGuideModal.classList.add('active');
      sizeGuideModal.style.display = 'flex';
      document.body.style.cssText = 'overflow:hidden!important;position:fixed!important;top:-' + scrollPosition + 'px;left:0;right:0;width:100%';
      document.body.classList.add('rug-modal-open');
    }

    function closeSizeGuideModal() {
      if (!sizeGuideModal) return;
      sizeGuideModal.classList.remove('active');
      sizeGuideModal.style.display = 'none';
      document.body.style.cssText = '';
      document.body.classList.remove('rug-modal-open');
      window.scrollTo(0, scrollPosition);
    }

    // Quality Modal Events
    if (qualityInfoBtn) qualityInfoBtn.addEventListener('click', function(e) { e.preventDefault(); openModal(); });
    if (modalClose) modalClose.addEventListener('click', function(e) { e.preventDefault(); closeModal(); });
    if (modalGotIt) modalGotIt.addEventListener('click', function(e) { e.preventDefault(); closeModal(); });
    if (modalOverlay) modalOverlay.addEventListener('click', function(e) { e.preventDefault(); closeModal(); });
    
    // Size Guide Modal Events
    if (sizeGuideBtn) sizeGuideBtn.addEventListener('click', function(e) { e.preventDefault(); openSizeGuideModal(); });
    if (sizeGuideClose) sizeGuideClose.addEventListener('click', function(e) { e.preventDefault(); closeSizeGuideModal(); });
    if (sizeGuideGotIt) sizeGuideGotIt.addEventListener('click', function(e) { e.preventDefault(); closeSizeGuideModal(); });
    if (sizeGuideOverlay) sizeGuideOverlay.addEventListener('click', function(e) { e.preventDefault(); closeSizeGuideModal(); });
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (modal && modal.classList.contains('active')) closeModal();
        if (sizeGuideModal && sizeGuideModal.classList.contains('active')) closeSizeGuideModal();
        if (isDropdownOpen) closeDropdown();
      }
    });

    // =====================
    // UPDATE QUALITY PRICES
    // =====================
    function updateAllQualityPrices(variants, size) {
      if (!size) return;

      qualityButtons.forEach(function(btn) {
        var qualityValue = btn.getAttribute('data-quality-value');
        
        var variant = variants.find(function(v) {
          return (v.option1 === size || v.option2 === size) && 
                 (v.option1 === qualityValue || v.option2 === qualityValue);
        });

        if (variant) {
          var salePrice = variant.price;
          var comparePrice = variant.compare_at_price;
          
          var salePriceEl = btn.querySelector('.rug-quality-btn__price-sale');
          if (salePriceEl) salePriceEl.textContent = formatMoney(salePrice);

          var comparePriceEl = btn.querySelector('.rug-quality-btn__price-original');
          if (comparePriceEl) {
            if (comparePrice && comparePrice > salePrice) {
              comparePriceEl.textContent = formatMoney(comparePrice);
              comparePriceEl.style.display = 'inline';
            } else {
              comparePriceEl.style.display = 'none';
            }
          }

          var savingsEl = btn.querySelector('.rug-quality-btn__savings');
          if (savingsEl) {
            if (comparePrice && comparePrice > salePrice) {
              var savedAmount = comparePrice - salePrice;
              var savedPercent = Math.round((savedAmount / comparePrice) * 100);
              var percentEl = savingsEl.querySelector('.savings-percent');
              var amountEl = savingsEl.querySelector('.savings-amount');
              if (percentEl) percentEl.textContent = savedPercent + '% OFF';
              if (amountEl) amountEl.textContent = '• Save ' + formatMoney(savedAmount);
              savingsEl.style.display = 'flex';
            } else {
              savingsEl.style.display = 'none';
            }
          }
        }
      });
    }

    // =====================
    // UPDATE VARIANT - MINIMOG EXACT SELECTORS
    // =====================
    function updateSelectedVariant(variants, size, quality) {
      if (!size || !quality) return;

      var matchingVariant = variants.find(function(v) {
        return (v.option1 === size || v.option2 === size) && 
               (v.option1 === quality || v.option2 === quality);
      });

      if (matchingVariant) {
        // Update hidden input
        if (variantIdInput) variantIdInput.value = matchingVariant.id;
        
        // Update URL
        updateURL(matchingVariant.id);
        
        // Update Minimog price display
        updateMinimogPrice(matchingVariant);
        
        // Trigger Minimog events
        triggerMinimogEvents(matchingVariant);
      }
    }

    // =====================
    // MINIMOG EXACT PRICE UPDATE
    // =====================
    function updateMinimogPrice(variant) {
      var price = variant.price;
      var comparePrice = variant.compare_at_price;
      var formattedPrice = formatMoney(price);
      var formattedCompare = comparePrice ? formatMoney(comparePrice) : '';

      // EXACT MINIMOG SELECTORS from screenshot
      // Sale price: .m-price-item--sale
      var salePriceElements = document.querySelectorAll('.m-price-item--sale');
      salePriceElements.forEach(function(el) {
        if (!el.closest('.rug-picker')) {
          el.textContent = formattedPrice;
        }
      });

      // Regular/Compare price: .m-price-item--regular (inside <s> tag)
      var regularPriceElements = document.querySelectorAll('.m-price-item--regular');
      regularPriceElements.forEach(function(el) {
        if (!el.closest('.rug-picker')) {
          if (comparePrice && comparePrice > price) {
            el.textContent = formattedCompare;
            // Show parent <s> if hidden
            var parentS = el.closest('s');
            if (parentS) parentS.style.display = '';
          } else {
            var parentS = el.closest('s');
            if (parentS) parentS.style.display = 'none';
          }
        }
      });

      // Also try direct <s> elements with price class
      var sElements = document.querySelectorAll('s.m-price-item');
      sElements.forEach(function(el) {
        if (!el.closest('.rug-picker')) {
          if (comparePrice && comparePrice > price) {
            el.textContent = formattedCompare;
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        }
      });

      // Update sale badge (SAVE XX%)
      var badges = document.querySelectorAll('.m-price__badges, [data-sale-badge-type]');
      badges.forEach(function(badge) {
        if (comparePrice && comparePrice > price) {
          var discount = Math.round(((comparePrice - price) / comparePrice) * 100);
          // Find or create badge text
          var badgeSpan = badge.querySelector('span') || badge;
          if (badgeSpan.textContent.includes('SAVE') || badgeSpan.textContent.includes('%')) {
            badgeSpan.textContent = 'SAVE ' + discount + '%';
          }
        }
      });

      // Fallback: Try other common selectors
      var fallbackSaleSelectors = [
        '.price-item--sale',
        '.price__current',
        '[data-product-price]'
      ];
      
      fallbackSaleSelectors.forEach(function(selector) {
        document.querySelectorAll(selector).forEach(function(el) {
          if (!el.closest('.rug-picker') && !el.classList.contains('m-price-item--sale')) {
            if (el.textContent.includes('$')) {
              el.textContent = formattedPrice;
            }
          }
        });
      });
    }

    // =====================
    // TRIGGER MINIMOG EVENTS
    // =====================
    function triggerMinimogEvents(variant) {
      // Update all variant inputs
      document.querySelectorAll('input[name="id"]').forEach(function(input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // Dispatch variant change event
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: variant },
        bubbles: true
      }));

      // Update forms
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = variant.id;
        form.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateURL(variantId) {
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url.toString());
      }
    }

    // =====================
    // INITIALIZE
    // =====================
    // Get first options
    var firstSizeOption = sizeOptions[0];
    var firstQualityBtn = qualityButtons[0];
    
    if (firstSizeOption) {
      selectedSize = firstSizeOption.getAttribute('data-size-value');
      // First one is already active from HTML
    }
    
    if (firstQualityBtn) {
      selectedQuality = firstQualityBtn.getAttribute('data-quality-value');
      // First one is already active from HTML
    }

    // Initialize prices
    setTimeout(function() {
      if (selectedSize) updateAllQualityPrices(variants, selectedSize);
      if (selectedSize && selectedQuality) updateSelectedVariant(variants, selectedSize, selectedQuality);
    }, 200);
  }

})();
